'use strict';

angular.module('theme').component('campaignCode', {
	bindings: {
		code: '<',
		testWeek: '<',
		expires: '<'
	},
	controller: function ($cookies) {
		var self = this;
		
		if (this.expires) {
			this.expires = moment(new Date(this.expires)).add(1, 'day').endOf('day').toDate();
		} else {
			this.expires = moment().add(1, 'month').toDate();
		}
		
		if(self.code) {
			$cookies.put('campaign-code', self.code, {
				path: '/',
				expires: self.expires
			});
			console.log('save campaign code', self.code);
		}

		if(self.testWeek) {
			$cookies.put('test-week', 'Test', {
				path: '/',
				expires: self.expires
			});
			console.log('save test week', self.testWeek);
		}
	}
});
